// extracted by mini-css-extract-plugin
export default {"home":"c-i_ea","home__background":"c-i_eb","home__content":"c-i_ec"};